module.exports = __webpack_public_path__ + "public/img/clustervet_icon.1f0eb40d.png";